module.exports = __webpack_public_path__ + "img/bid_icon.0ba329fe.svg";